{
  "book": {
    "brand": "Smart Word Labs",
    "breadcrumb": "Réserver une évaluation gratuite",
    "errors": {
      "generic": "Impossible de réserver votre évaluation"
    },
    "success": {
      "title": "Évaluation réservée !",
      "body": "Consultez vos e-mails pour la confirmation et les détails de connexion. Nous avons envoyé un lien de connexion sécurisé à",
      "bodyEnd": "afin que vous puissiez accéder à votre portail parent sans mot de passe.",
      "backHome": "Retour à l'accueil"
    },
    "form": {
      "title": "Réservez votre évaluation gratuite",
      "subtitle": "Cela prend moins d'une minute. Aucun compte ni coordonnées de paiement requis — nous configurerons votre portail parent pour vous.",
      "parentName": "Nom du parent",
      "parentEmail": "E-mail du parent",
      "childName": "Nom de l'enfant",
      "childAge": "Âge de l'enfant",
      "date": "Date préférée",
      "time": "Heure préférée",
      "booking": "Réservation…",
      "submit": "Réserver l'évaluation gratuite",
      "alreadyEnrolled": "Déjà inscrit ?",
      "parentSignIn": "Connexion Parent",
      "localTimeNote": "Horaires dans votre fuseau horaire"
    }
  },
  "checkout": {
    "title": "Paiement sécurisé",
    "summary": "{{name}} — {{monthly}} $ par mois, {{lessons}}. Annulez à tout moment.",
    "couldNotStart": "Le paiement n'a pas pu être initié",
    "choosePlan": {
      "before": "Choisissez un forfait sur la",
      "link": "page des tarifs",
      "after": "pour continuer."
    },
    "summaryOneTime": "{{name}} — {{monthly}} USD paiement unique, {{lessons}}."
  },
  "contact": {
    "breadcrumb": "Contactez-nous",
    "title": "Contactez-nous",
    "subtitle": "Utilisez le formulaire ci-dessous et nous vous répondrons personnellement dans un délai d'un jour ouvrable.",
    "eyebrow": "Parlez-nous",
    "heading": "Des questions sur l'anglais de votre enfant ?",
    "description": "Envoyez un message et Mme Salma vous répondra personnellement. Partagez votre numéro WhatsApp si vous préférez une note vocale rapide ou un appel au lieu d'un e-mail.",
    "bullets": {
      "email": "Nous répondons par e-mail dans un délai d'un jour ouvrable (lun–sam).",
      "whatsapp": "Vous préférez WhatsApp ? Ajoutez votre numéro et nous vous y contacterons."
    },
    "form": {
      "name": "Nom du parent",
      "email": "E-mail",
      "whatsapp": "Numéro WhatsApp (facultatif)",
      "dialCodeAria": "Indicatif téléphonique du pays",
      "whatsappPlaceholder": "06 12 34 56 78",
      "childAge": "Âge de l'enfant (facultatif)",
      "childAgePlaceholder": "ex. 7",
      "subject": "Sujet (facultatif)",
      "subjectPlaceholder": "Horaires des cours, tarifs, évaluation…",
      "message": "Message",
      "sending": "Envoi…",
      "pleaseWait": "Veuillez patienter {{seconds}}s…",
      "send": "Envoyer le message",
      "sentTitle": "Message reçu",
      "sentBody": "Merci — nous avons vos coordonnées et nous vous contacterons prochainement.",
      "sendAnother": "Envoyer un autre message",
      "privacyBefore": "Nous utilisons vos coordonnées uniquement pour répondre à cette demande. Consultez notre",
      "privacyLink": "avis de confidentialité",
      "success": "Message envoyé — nous vous répondrons dans un délai d'un jour ouvrable.",
      "validation": {
        "nameRequired": "Veuillez entrer votre nom",
        "emailInvalid": "Veuillez entrer une adresse e-mail valide",
        "whatsappTooLong": "Le numéro WhatsApp est trop long",
        "whatsappFormat": "Utilisez uniquement des chiffres, des espaces, + ou -",
        "messageTooShort": "Veuillez nous en dire un peu plus"
      },
      "errors": {
        "tooFast": "C'était rapide ! Veuillez prendre un moment et réessayer.",
        "checkForm": "Veuillez vérifier le formulaire",
        "captcha": "Nous n'avons pas pu vérifier cet envoi. Veuillez réessayer.",
        "sendFailed": "Nous n'avons pas pu envoyer votre message. Veuillez réessayer."
      }
    }
  },
  "howItWorks": {
    "breadcrumb": "Comment ça marche",
    "hero": {
      "title": "Comment fonctionnent nos cours d'anglais en ligne",
      "subtitle": "Petits groupes. Grande confiance à l'oral. Chaque enfant est évalué, placé et suivi selon les critères du CECRL, puis reçoit un enseignement en direct dans une cohorte de cinq élèves maximum."
    },
    "pillars": {
      "title": "Nos trois principes d'enseignement"
    },
    "steps": {
      "title": "De la demande au premier cours"
    },
    "cta": {
      "book": "Réserver une évaluation gratuite",
      "browsePrograms": "Parcourir les programmes par âge",
      "seePricing": "Voir les tarifs"
    }
  },
  "pricing": {
    "breadcrumb": "Tarifs",
    "compareLink": "Vous ne savez pas quel niveau choisir ? Comparez les programmes"
  },
  "paymentBanner": {
    "notConfigured": "Le paiement en production n'est pas encore configuré. Terminez la mise en service du paiement pour accepter des paiements réels.",
    "testMode": "Tous les paiements effectués dans l'aperçu sont en mode test.",
    "testModeLink": "Voir la documentation du mode test de paiement",
    "notReady": "Les paiements en direct ne sont pas encore tout à fait prêts : {{failures}}. Nouvelle vérification automatique."
  },
  "faq": {
    "title": "Questions que les parents nous posent",
    "subtitle": "Évaluation gratuite, technologie, planification, paiements, placement et remboursements — réponses complètes.",
    "items": [
      {
        "q": "L'évaluation gratuite est-elle vraiment gratuite, et comment se déroule-t-elle ?",
        "a": "Oui — la première session est une évaluation totalement gratuite de 20 à 30 minutes avec Mme Salma, sans coordonnées bancaires requises. Votre enfant discute, lit et effectue une courte tâche d'expression orale pendant qu'elle l'évalue par rapport aux niveaux du CECRL. Dans un délai d'un jour ouvrable, vous recevrez un plan d'apprentissage écrit et une cohorte recommandée. Il n'y a aucune obligation d'inscription par la suite."
      },
      {
        "q": "De quel équipement et de quelle vitesse Internet avons-nous besoin ?",
        "a": "Un ordinateur portable, de bureau ou une tablette avec une webcam et une connexion stable d'environ 5 Mbps suffisent — les cours se déroulent dans le navigateur via Zoom, il n'y a donc rien à installer au-delà de cela. Un casque avec microphone fait une grande différence pour les plus jeunes enfants, et un endroit calme et bien éclairé les aide à rester concentrés. Les téléphones fonctionnent en cas de besoin, mais l'écran est trop petit pour les tâches de lecture partagée."
      },
      {
        "q": "Comment reprogrammer ou annuler un cours ?",
        "a": "Reprogrammez depuis le portail parent au moins 12 heures avant le cours. Chaque forfait comprend des crédits de reprogrammation (2 pour le forfait Starter, 4 pour l'Intensif, illimités pour le Privé). Au-delà, nous essaierons de placer votre enfant dans une autre cohorte du même niveau cette semaine-là sans frais supplémentaires, et si rien ne convient, votre enseignant envoie une tâche de rattrapage enregistrée et comble l'écart lors du cours suivant."
      },
      {
        "q": "Quels modes de paiement acceptez-vous, et est-ce sécurisé ?",
        "a": "Les forfaits sont facturés mensuellement en USD via Stripe, qui accepte Visa, Mastercard, American Express, Apple Pay, Google Pay et la plupart des réseaux de cartes locaux. Nous ne voyons ni ne stockons jamais votre numéro de carte — tout est géré sur le paiement sécurisé de Stripe, conforme aux normes PCI. Vous pouvez mettre à jour votre carte ou annuler à tout moment depuis le portail parent, et l'annulation arrête simplement le prochain renouvellement."
      },
      {
        "q": "Comment mon enfant est-il placé dans le bon groupe d'âge et le bon niveau ?",
        "a": "Le placement se fait d'abord par niveau CECRL, puis par tranche d'âge, de sorte qu'un enfant de six ans confiant n'est jamais freiné et qu'un enfant de neuf ans plus réservé n'est jamais dépassé. L'évaluation gratuite nous donne le niveau ; les tranches d'âge (4–6 Explorateurs de la phonétique précoce, 7–9 Bâtisseurs de littératie, 10–12 Communicateurs confiants) décident ensuite du rythme, du matériel et de la durée des cours. Si un enfant dépasse le niveau d'une cohorte en milieu de trimestre, nous le déplaçons sans frais."
      },
      {
        "q": "Quelle est votre politique de remboursement ?",
        "a": "Si vous n'êtes pas satisfait après le premier mois payé de votre enfant, envoyez-nous un e-mail dans les 14 jours suivant ce premier débit et nous vous rembourserons intégralement. Après cela, l'annulation arrête le prochain renouvellement et vous conservez chaque cours déjà payé jusqu'à la fin du mois de facturation — nous ne facturons pas de frais d'annulation. Tous les détails figurent dans notre politique de remboursement."
      },
      {
        "q": "Comment saurai-je que mon enfant progresse ?",
        "a": "Chaque enfant est évalué selon les niveaux du CECR au départ. Vous recevez un rapport de progression écrit chaque mois et, si les progrès sont plus lents que prévu, Ms. Salma ajuste le plan d'apprentissage et en discute avec vous."
      }
    ]
  },
  "faculty": {
    "title": "Rencontrez votre enseignante",
    "subtitle": "Chaque cours est dispensé par Mme Salma, une spécialiste de l'anglais pour jeunes apprenants certifiée CELTA, travaillant à partir de notre programme aligné sur le CECRL.",
    "teacher": {
      "name": "Mme Salma",
      "credential": "Certifiée CELTA (Cambridge English) · Licence en anglais et psychologie appliquée",
      "experience": "Plus de 10 ans d'enseignement de l'anglais, du primaire à l'adulte, à travers le Canada et le Moyen-Orient",
      "detail": "Littératie précoce et phonétique du programme britannique, cours alignés sur le CECRL, coaching pour l'IELTS et les entretiens.",
      "quote": "La phonétique s'ancre quand elle ressemble à un jeu, pas à un exercice.",
      "photoAlt": "Mme Salma, enseignante d'anglais certifiée CELTA chez Smart Word Labs"
    }
  },
  "testimonials": {
    "title": "Ce que les parents disent de nos cours d'anglais en ligne",
    "ratingSummary": "4,9/5 basé sur plus de 1 200 avis de parents vérifiés",
    "starsAria": "{{rating}} étoiles sur 5",
    "prevAria": "Avis précédents",
    "nextAria": "Avis suivants",
    "pageAria": "Afficher la page d'avis {{page}}",
    "reviews": [
      {
        "quote": "Aariz est passé de réponses d'un seul mot à nous raconter des histoires complètes sur son cours. La cohorte de quatre signifie qu'il doit réellement parler — cela a tout changé.",
        "name": "Sana M.",
        "childAge": "Parent d'un enfant de 6 ans",
        "location": "Dubaï, Émirats Arabes Unis",
        "rating": 5
      },
      {
        "quote": "Le rapport mensuel CECRL est la première chose que j'ai eue qui montre réellement des progrès plutôt que juste 'elle se débrouille bien'. Ça vaut chaque centime.",
        "name": "Rachel T.",
        "childAge": "Parent d'un enfant de 9 ans",
        "location": "Londres, Royaume-Uni",
        "rating": 5
      },
      {
        "quote": "Mes deux enfants sont sur le même compte et je peux voir leurs cours côte à côte. Reprogrammer prend dix secondes.",
        "name": "Ibrahim K.",
        "childAge": "Parent de deux enfants, âgés de 7 et 11 ans",
        "location": "Karachi, Pakistan",
        "rating": 5
      },
      {
        "quote": "Bâtisseurs de littératie a transformé la lecture, d'une corvée en quelque chose qu'elle demande. Son écriture à l'école a bondi d'un niveau entier en un trimestre.",
        "name": "Priya N.",
        "childAge": "Parent d'un enfant de 8 ans",
        "location": "Singapour",
        "rating": 5
      },
      {
        "quote": "Communicateurs confiants est exactement ce dont notre fils avait besoin avant le collège — il présente maintenant un argument à table sans hésiter.",
        "name": "Marco B.",
        "childAge": "Parent d'un enfant de 11 ans",
        "location": "Milan, Italie",
        "rating": 5
      },
      {
        "quote": "Les cours de phonétique précoce ne durent que 30 minutes, ce qui est parfait pour la capacité d'attention d'un enfant de cinq ans. Il déchiffre les mots partout où nous allons maintenant.",
        "name": "Hannah L.",
        "childAge": "Parent d'un enfant de 5 ans",
        "location": "Manchester, Royaume-Uni",
        "rating": 5
      },
      {
        "quote": "Nous avons utilisé le programme de préparation aux entretiens avant les évaluations d'entrée. Notre fille y est allée vraiment détendue et a obtenu sa place de premier choix.",
        "name": "Elena V.",
        "childAge": "Parent d'un enfant de 10 ans",
        "location": "Madrid, Espagne",
        "rating": 5
      },
      {
        "quote": "Mme Salma a remarqué en deux cours que mon fils devinait au lieu de décoder. Personne à l'école ne l'avait remarqué en un an.",
        "name": "Yusuf A.",
        "childAge": "Parent d'un enfant de 7 ans",
        "location": "Doha, Qatar",
        "rating": 5
      },
      {
        "quote": "L'évaluation gratuite à elle seule a été plus utile que les essais payants que nous avons faits ailleurs. Nous nous sommes inscrits la même semaine et nous ne l'avons pas regretté.",
        "name": "Claire D.",
        "childAge": "Parent d'un enfant de 9 ans",
        "location": "Toronto, Canada",
        "rating": 4
      }
    ]
  },
  "placementQuiz": {
    "eyebrow": "Placement en 30 secondes",
    "title": "Trouvez la bonne cohorte en 30 secondes",
    "subtitle": "Trois questions rapides et nous vous orienterons vers le programme qui correspond à votre enfant.",
    "stepOf": "Étape {{current}} sur {{total}}",
    "back": "← Retour",
    "recommended": "Programme recommandé",
    "bookCta": "Réserver votre évaluation gratuite",
    "seeFullProgramme": "Voir le programme complet",
    "startAgain": "Recommencer",
    "reasons": {
      "new": "Nous commencerons par des sons et des réponses orales courtes afin que votre enfant renforce sa confiance avant de passer au rythme supérieur.",
      "confident": "Votre enfant est prêt pour des prises de parole plus longues, les cours mettent donc l'accent sur la structure, le vocabulaire et l'argumentation.",
      "default": "Les cours équilibrent la pratique guidée avec beaucoup de temps de parole indépendant."
    },
    "steps": [
      {
        "key": "age",
        "title": "Quel âge a votre enfant ?",
        "options": [
          {
            "value": "4-6",
            "label": "4–6 ans"
          },
          {
            "value": "7-9",
            "label": "7–9 ans"
          },
          {
            "value": "10-12",
            "label": "10–12 ans"
          }
        ]
      },
      {
        "key": "goal",
        "title": "Qu'est-ce qui compte le plus en ce moment ?",
        "options": [
          {
            "value": "phonics",
            "label": "Lecture et phonétique"
          },
          {
            "value": "writing",
            "label": "Écriture et travail scolaire"
          },
          {
            "value": "speaking",
            "label": "Confiance à l'oral"
          },
          {
            "value": "exams",
            "label": "Examens et entretiens"
          }
        ]
      },
      {
        "key": "comfort",
        "title": "Quel est le niveau de confort de votre enfant pour parler anglais ?",
        "options": [
          {
            "value": "new",
            "label": "Débute tout juste"
          },
          {
            "value": "some",
            "label": "Quelques phrases"
          },
          {
            "value": "confident",
            "label": "Discute assez librement"
          }
        ]
      }
    ]
  },
  "cohortTimeConverter": {
    "intro": "Ms. Salma enseigne depuis Toronto. Horaires des cours dans votre fuseau horaire :",
    "timezoneLabel": "Votre fuseau horaire",
    "timezonePlaceholder": "Sélectionnez votre fuseau horaire",
    "footnote": "Horaires affichés dans votre heure locale. Votre créneau exact est confirmé lors de l'évaluation gratuite."
  }
}
